module.exports = __webpack_public_path__ + "images/smartphone-screen-2_ea1b5e6cd9b171c2d4fbd1e39307a8a4.png";